import React from "react";

/* Shield — the "we will verify this" reassurance note. */
export const ShieldIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <path d="M12 3l7 3v5.5c0 4.3-2.9 8.2-7 9.5-4.1-1.3-7-5.2-7-9.5V6l7-3z"
          stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
  </svg>
);

export default ShieldIcon;
